var selectGroup = 'fx_2d2fb1e5_1xbhsnk0';

export { selectGroup };
//# sourceMappingURL=group.vanilla.mjs.map
